/** Config de campos vinculados (misma semántica que el wizard móvil). */

/** Mismo azul que campos rellenos de ModalNuevaPrecaptacion (`#3b82f6` / chip Historial «Todos»). */
export const ACC_MOVIL = '#3b82f6';
export const BEIGE_MOVIL = '#e8e8e0';
export const BRD_MOVIL = '#c8c8be';
/** Títulos de campo en el modal agente (legible sobre fondo oscuro del CRM). */
export const LABEL_MOVIL = '#22c55e';

export const GARAJE_TIPO_OPCIONES = ['Abierto', 'Cerrado', 'Cubierto', 'Interior', 'Exterior'];

/** Parejas excluyentes: Abierto↔Cerrado, Interior↔Exterior. Cubierto es compatible con ambas. */
export const GARAJE_TIPO_EXCLUSIVOS = {
  abierto: ['cerrado'],
  cerrado: ['abierto'],
  interior: ['exterior'],
  exterior: ['interior'],
};

/** Toggle multi con exclusión por pareja. `selected` = keys en minúsculas. */
export function toggleGarajeTipoExclusivo(selected, val) {
  const v = String(val || '').toLowerCase();
  if (!v) return Array.isArray(selected) ? selected.slice() : [];
  const set = new Set((selected || []).map((x) => String(x).toLowerCase()));
  if (set.has(v)) {
    set.delete(v);
  } else {
    set.add(v);
    (GARAJE_TIPO_EXCLUSIVOS[v] || []).forEach((r) => set.delete(r));
  }
  return GARAJE_TIPO_OPCIONES
    .map((o) => o.toLowerCase())
    .filter((k) => set.has(k));
}

/** Si hay ambos de una pareja (datos viejos), gana el último en el array. */
export function sanitizarGarajeTiposExclusivos(tipos) {
  const arr = Array.isArray(tipos) ? tipos : [];
  let out = [];
  const seen = Object.create(null);
  for (let i = 0; i < arr.length; i++) {
    const v = String(arr[i] || '').toLowerCase();
    if (!v || seen[v]) continue;
    const rivals = GARAJE_TIPO_EXCLUSIVOS[v] || [];
    for (let r = 0; r < rivals.length; r++) {
      if (seen[rivals[r]]) {
        out = out.filter((x) => x !== rivals[r]);
        delete seen[rivals[r]];
      }
    }
    out.push(v);
    seen[v] = 1;
  }
  return out;
}

export const TOGGLE_DETALLE_CFG = {
  eq_trastero: {
    detailKey: 'num_trastero',
    title: 'Trastero',
    label: 'Nº trastero',
    placeholder: 'Ej: 12 / T-3 (o 0 si no tiene número)',
    hint: 'Indica el número del trastero. Si no tiene número, pon 0. Sin este dato no se activa el trastero.',
    quitarLabel: 'Quitar trastero',
    optional: false,
  },
  vpo: {
    detailKey: 'vpo_fecha_fin',
    anoFinKey: 'vpo_ano_fin',
    title: 'VPO',
    label: 'Fecha de vencimiento',
    placeholder: '',
    hint: 'Indica hasta cuándo está protegida la vivienda (VPO).',
    quitarLabel: 'Quitar VPO',
    inputType: 'date',
    optional: true,
  },
  cocina_amueblada: {
    detailKey: 'cocina_amueblada_obs',
    title: 'Cocina amueblada',
    label: 'Detalle',
    placeholder: 'Opcional',
    hint: 'Detalle de la cocina amueblada (opcional).',
    quitarLabel: 'Quitar',
    optional: true,
  },
  armarios: {
    detailKey: 'armarios_obs',
    title: 'Armarios',
    label: 'Detalle',
    placeholder: 'Opcional',
    hint: 'Detalle de armarios (opcional).',
    quitarLabel: 'Quitar',
    optional: true,
  },
  eq_garaje: {
    detailKey: 'num_garaje',
    title: 'Garaje',
    label: 'Nº garaje',
    placeholder: 'Ej: 45 / G-2 (o 0 si no tiene número)',
    hint: 'Indica el número o plaza del garaje. Si no tiene número, pon 0. Sin este dato no se activa el garaje.',
    quitarLabel: 'Quitar garaje',
    optional: false,
    encadenarTipos: true,
  },
};

export const TOGGLE_SELECTOR_CFG = {
  eq_calefaccion: {
    detailKey: 'eq_calefaccion_id',
    title: 'Calefacción',
    quitarLabel: 'Quitar calefacción',
    auxSlug: 'calefaccion',
  },
  eq_aire: {
    detailKey: 'eq_aire_id',
    title: 'Aire acondicionado',
    quitarLabel: 'Quitar aire',
    auxSlug: 'aire-acondicionado',
  },
  eq_piscina_comun: {
    detailKey: 'eq_piscina_comun_id',
    title: 'Piscina comunitaria',
    quitarLabel: 'Quitar piscina',
    auxSlug: 'piscina',
  },
  eq_piscina_priv: {
    detailKey: 'eq_piscina_priv_id',
    title: 'Piscina privada',
    quitarLabel: 'Quitar piscina',
    auxSlug: 'piscina',
  },
};

export const TOGGLE_FLAGS_CFG = {
  ub_primera_linea: {
    title: '1ª línea playa',
    quitarLabel: 'Quitar 1ª línea',
    requireOne: true,
    fields: [
      { key: 'ub_dpmt', label: 'DPMT', obs: true },
      { key: 'ub_serv_transito', label: 'Serv. Tránsito', obs: true },
      { key: 'ub_serv_proteccion', label: 'Serv. Protección', obs: true },
      { key: 'ub_afectacion_costas', label: 'No afectado', obs: true, exclusive: true },
    ],
  },
  primera_linea: {
    title: '1ª línea playa',
    quitarLabel: 'Quitar 1ª línea',
    requireOne: true,
    fields: [
      { key: 'ub_dpmt', label: 'DPMT', obs: true },
      { key: 'ub_serv_transito', label: 'Serv. Tránsito', obs: true },
      { key: 'ub_serv_proteccion', label: 'Serv. Protección', obs: true },
      { key: 'ub_afectacion_costas', label: 'No afectado', obs: true, exclusive: true },
    ],
  },
};

/** Claves de detalle que no deben listarse sueltas si el padre se gestiona por modal. */
export const DETAIL_KEYS_OCULTAS = new Set([
  'num_trastero', 'num_garaje', 'vpo_ano_fin', 'vpo_fecha_fin',
  'cocina_amueblada_obs', 'armarios_obs',
  'muebles_id', 'garaje_tipos', 'garajes_plazas_detalle',
  'ub_afectacion_costas', 'ub_afectacion_costas_obs',
  'ub_dpmt', 'ub_dpmt_obs',
  'ub_serv_transito', 'ub_serv_transito_obs',
  'ub_serv_proteccion', 'ub_serv_proteccion_obs',
]);

/** Detalle de selectores (aire/calefacción/piscina): se listan como desplegable con el título del campo. */
export const DETAIL_KEYS_DESPLEGABLE = new Set([
  'eq_calefaccion_id', 'eq_aire_id', 'eq_piscina_comun_id', 'eq_piscina_priv_id',
]);

export function toggleUsaModalDetalle(k) {
  return !!(k && TOGGLE_DETALLE_CFG[k]);
}

export function toggleUsaModalSelector(k) {
  return !!(k && TOGGLE_SELECTOR_CFG[k]);
}

export function toggleUsaModalFlags(k) {
  return !!(k && TOGGLE_FLAGS_CFG[k]);
}

export function toggleUsaModalVinculo(k) {
  return toggleUsaModalDetalle(k) || toggleUsaModalSelector(k) || toggleUsaModalFlags(k) || k === 'exclusiva';
}

/** Si en pendientes solo está el *_id, mapear al toggle padre para el modal. */
export function padreDeDetailKey(detailKey) {
  for (const [parent, cfg] of Object.entries(TOGGLE_SELECTOR_CFG)) {
    if (cfg.detailKey === detailKey) return parent;
  }
  for (const [parent, cfg] of Object.entries(TOGGLE_DETALLE_CFG)) {
    if (cfg.detailKey === detailKey || cfg.anoFinKey === detailKey) return parent;
  }
  for (const [parent, cfg] of Object.entries(TOGGLE_FLAGS_CFG)) {
    for (const f of cfg.fields || []) {
      if (f.key === detailKey) return parent;
      if (f.obs && `${f.key}_obs` === detailKey) return parent;
    }
  }
  return null;
}

export function estiloSelBtnMovil(activo, { fontSize = 16 } = {}) {
  return {
    flex: 1,
    minWidth: 0,
    padding: '14px 4px',
    borderRadius: 12,
    border: `2px solid ${activo ? ACC_MOVIL : BRD_MOVIL}`,
    background: activo ? ACC_MOVIL : BEIGE_MOVIL,
    color: activo ? '#fff' : '#000',
    fontFamily: 'inherit',
    fontSize,
    fontWeight: 700,
    cursor: 'pointer',
    textAlign: 'center',
    WebkitAppearance: 'none',
    transition: 'all 0.15s',
  };
}

/** ¿El campo tiene valor (azul #3b82f6) o está vacío (beige)? Misma lógica que .f-inp.has-value en móvil. */
export function campoTieneValor(val) {
  if (val == null) return false;
  if (typeof val === 'boolean') return true;
  if (typeof val === 'number') return !Number.isNaN(val);
  return String(val).trim() !== '';
}

/**
 * Input/select móvil: beige vacío, azul `#3b82f6` (mismo que precaptación) con texto blanco si tiene valor.
 * Preferir también className `agente-f-inp` (+ `has-value`) para autofill y selects.
 */
export function estiloInpMovil(hasValue = false) {
  const filled = !!hasValue;
  return {
    width: '100%',
    padding: '13px 14px',
    fontSize: 15,
    border: `2px solid ${filled ? ACC_MOVIL : BRD_MOVIL}`,
    borderRadius: 12,
    background: filled ? ACC_MOVIL : BEIGE_MOVIL,
    color: filled ? '#fff' : '#000',
    outline: 'none',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    WebkitAppearance: 'none',
  };
}

export function claseInpMovil(hasValue = false) {
  return `agente-f-inp${hasValue ? ' has-value' : ''}`;
}

/** Botones «+ Añadir otro propietario» / «+ Añadir contacto» (.cap4-add-btn). */
export function estiloAddBtnMovil(kind = 'prop') {
  const isCont = kind === 'cont';
  return {
    flex: 1,
    minWidth: 140,
    marginTop: 0,
    padding: '12px 8px',
    borderRadius: 12,
    border: `2px solid ${isCont ? '#2563eb' : '#15803d'}`,
    background: isCont ? '#eff6ff' : '#f0fdf4',
    color: isCont ? '#1d4ed8' : '#15803d',
    fontFamily: 'inherit',
    fontWeight: 700,
    fontSize: 12,
    cursor: 'pointer',
    lineHeight: 1.25,
  };
}
